import React from "react"
import Prose from "../utility/prose";
import axios from 'axios'

class DistrictSearch extends React.Component {
    constructor(props) {
        super(props);
        this.data = props.data

        this.state = {
            form_address: '',
            formatted_address: '',
            lat: '',
            lng: '',
            district_name: '',
            district_geo: '',
            formError: [],
            formSuccess: '',
            form_address2: '',
            formatted_address2: '',
            lat2: '',
            lng2: '',
            district_name2: '',
            district_geo2: '',
            formError2: [],
            formSuccess2: '',
        }
    }

    submit = (event) => {
        event.preventDefault()
        this.setState( { formSuccess: '', formError: [] }, this.handleFormEntry )
    }

    handleFormEntry = () => {
        if( this.state.form_address  === '' ) {
            this.setState({ formError: this.state.formError.concat(["Form not filled out completely."]) })
        } else {

            axios.get('https://geo.tsds.info/api/get-district?address='+encodeURI(this.state.form_address)+'&districts=%5B%7B%22name%22%3A%22Harris%20County%20MUD%20418%22%7D%2C%7B%22name%22%3A%22Harris%20County%20MUD%20419%22%7D%2C%7B%22name%22%3A%22Harris%20County%20MUD%20489%22%7D%2C%7B%22name%22%3A%22Harris%20County%20MUD%20490%22%7D%2C%7B%22name%22%3A%22Harris%20County%20MUD%20491%22%7D%2C%7B%22name%22%3A%22Harris%20County%20MUD%20492%22%7D%2C%7B%22name%22%3A%22Harris%20County%20MUD%20493%22%7D%5D').then( function(response) {
                console.log('Response');
                console.log(response.data);
                this.clearForm();
                this.setState({ 
                    formSuccess: "Found the following address",
                    formatted_address: response.data.formatted_address,
                    lat: response.data.lat,
                    lng: response.data.lng,
                    district_name: response.data.district_name,
                    district_geo: response.data.district_geo,
                });

            }.bind(this) ).catch( function(error) {
                console.log(error.response)
            })

        }
    }

    clearForm = () => {
        this.setState({ form_address: '', formError: [] });
    }
    reset = () => {
        this.setState({ form_address: '', formError: [], formSuccess:'', formatted_address: '', lat: '', lng: '', district_geo: '', district_name: '' });
    }
    changeAddress = (event) => {
        this.setState({ form_address: event.target.value })
    }
    submit2 = (event) => {
        event.preventDefault()
        this.setState( { formSuccess2: '', formError2: [] }, this.handleFormEntry2 )
    }

    handleFormEntry2 = () => {
        if( this.state.form_address2  === '' ) {
            this.setState({ formError2: this.state.formError2.concat(["Form not filled out completely."]) })
        } else {

            axios.get('https://geo.tsds.info/api/get-district?address='+encodeURI(this.state.form_address2)+'&districts=%5B%7B%22name%22%3A%22Harris%20County%20WCID%20158%22%7D%2C%7B%22name%22%3A%22Harris%20County%20WCID%20159%22%7D%5D').then( function(response) {
                console.log('Response');
                console.log(response.data);
                this.clearForm();
                this.setState({ 
                    formSuccess2: "Found the following address",
                    formatted_address2: response.data.formatted_address,
                    lat2: response.data.lat,
                    lng2: response.data.lng,
                    district_name2: response.data.district_name,
                    district_geo2: response.data.district_geo,
                });

            }.bind(this) ).catch( function(error) {
                console.log(error.response)
            })

        }
    }

    clearForm2 = () => {
        this.setState({ form_address2: '', formError2: [] });
    }
    reset2 = () => {
        this.setState({ form_address2: '', formError2: [], formSuccess2:'', formatted_address2: '', lat2: '', lng2: '', district_geo2: '', district_name2: '' });
    }
    changeAddress2 = (event) => {
        this.setState({ form_address2: event.target.value })
    }


    render() {
        return (
            <Prose>
            <div className="w-full md:w-5/6 lg:w-2/3 mx-auto">
                { this.state.formSuccess === '' ? ( 
                    <form className="form" onSubmit={this.submit}>
                        <div className="mb-2">
                            <label className="text-sm uppercase pl-6">Enter your address to search for your MUD:</label>
                            <div className="control">
                                <input className={`block w-full rounded-full bg-zinc-200 dark:bg-zinc-800 border-0 pl-6 ${this.state.formError.length !== 0 ? 'is-danger':''}`} type="text" placeholder="Enter your home address" onChange={this.changeAddress} value={this.state.form_address}></input>
                            </div>
                        </div>
                        <div className="field">
                            <div className="control">
                                <input className="inline-block text-base uppercase bg-emerald-300 hover:bg-emerald-400 dark:bg-emerald-700 hover:dark:bg-emerald-800 mr-1 mb-2 px-4 py-2 rounded-full leading-none" type="submit" value="Find My MUD" />
                            </div>
                        </div>  
                        { this.state.formError.length !== 0 ? (<div className="list-none text-red-500 dark:text-red-400 border-red-400 dark:border-red-400 border-2 rounded-3xl pl-6">{this.state.formError.map((error) => (
                            <div key={error} >{error}</div>
                        )) }</div>): < ></ > }
                    </form>
                ) : (
                    <>
                        <div className="notification is-primary">{this.state.formSuccess}</div>
                        <h3 style={{fontWeight: 600}} className="is-title is-size-5">{this.state.formatted_address}</h3>
                        {this.state.district_name !== '' ? (
                            <>
                                <p style={{marginTop: '1rem'}}>Your MUD is {this.state.district_name}</p>
                                <a className="button" href={`${
                                    this.state.district_name === "Harris County MUD 418" ? "/harris-county-mud-418" : ""}${
                                    this.state.district_name === "Harris County MUD 419" ? "/harris-county-mud-419" : ""}${
                                    this.state.district_name === "Harris County MUD 489" ? "/harris-county-mud-489" : ""}${
                                    this.state.district_name === "Harris County MUD 490" ? "/harris-county-mud-490" : ""}${
                                    this.state.district_name === "Harris County MUD 491" ? "/harris-county-mud-491" : ""}${
                                    this.state.district_name === "Harris County MUD 492" ? "/harris-county-mud-492" : ""}${
                                    this.state.district_name === "Harris County MUD 493" ? "/harris-county-mud-493" : ""}`}>View MUD</a>
                            </>
                        ) : (
                            <>
                                <p style={{marginTop: '1rem'}}>Your District was not found!</p>
                                <button className="inline-block text-base uppercase bg-emerald-300 hover:bg-emerald-400 dark:bg-emerald-700 hover:dark:bg-emerald-800 mr-1 mb-2 px-4 py-2 rounded-full leading-nonea" onClick={this.reset} >Try Again</button>
                            </>
                        )}
                    </>
                )}
                <hr />
                { this.state.formSuccess2 === '' ? ( 
                    <form className="form" onSubmit={this.submit2}>
                        <div className="mb-2">
                            <label className="text-sm uppercase pl-6">Enter your address to search for your WCID:</label>
                            <div className="control">
                                <input className={`block w-full rounded-full bg-zinc-200 dark:bg-zinc-800 border-0 pl-6 ${this.state.formError2.length !== 0 ? 'is-danger':''}`} type="text" placeholder="Enter your home address" onChange={this.changeAddress2} value={this.state.form_address2}></input>
                            </div>
                        </div>
                        <div className="field">
                            <div className="control">
                                <input className="inline-block text-base uppercase bg-emerald-300 hover:bg-emerald-400 dark:bg-emerald-700 hover:dark:bg-emerald-800 mr-1 mb-2 px-4 py-2 rounded-full leading-none" type="submit" value="Find My WCID" />
                            </div>
                        </div>  
                        { this.state.formError2.length !== 0 ? (<div className="list-none text-red-500 dark:text-red-400 border-red-400 dark:border-red-400 border-2 rounded-3xl pl-6">{this.state.formError2.map((error) => (
                            <div key={error} >{error}</div>
                        )) }</div>): < ></ > }
                    </form>
                ) : (
                    <>
                        <div className="notification is-primary">{this.state.formSuccess2}</div>
                        <h3 style={{fontWeight: 600}} className="is-title is-size-5">{this.state.formatted_address2}</h3>
                        {this.state.district_name2 !== '' ? (
                            <>
                                <p style={{marginTop: '1rem'}}>Your WCID is {this.state.district_name2}</p>
                                <a className="button" href={`${
                                    this.state.district_name2 === "Harris County WCID 158" ? "/harris-county-wcid-158" : ""}${
                                    this.state.district_name2 === "Harris County WCID 159" ? "/harris-county-wcid-159" : ""}`}>View WCID</a>
                            </>
                        ) : (
                            <>
                                <p style={{marginTop: '1rem'}}>Your District was not found!</p>
                                <button className="inline-block text-base uppercase bg-emerald-300 hover:bg-emerald-400 dark:bg-emerald-700 hover:dark:bg-emerald-800 mr-1 mb-2 px-4 py-2 rounded-full leading-none" onClick={this.reset2} >Try Again</button>
                            </>
                        )}
                    </>
                )}
                <hr />
            </div>
            </Prose>
        )
    }
}

export default DistrictSearch